import {
    DEFAULT_LANGUAGE_ISO_CODE,
    LANGUAGE_ISO_CODES,
} from '@shared/config/lang.js'

export const config = {
    defaultLanguage: DEFAULT_LANGUAGE_ISO_CODE,
    get currentLanguage() {
        return LANGUAGE_ISO_CODES[window.Store.locale]
    },
}

/**
 * Get the first node.
 *
 * @param {Array} edges
 * @returns {object}
 */
export function getSingletonData(edges = []) {
    if (!edges.length) {
        return
    }

    return edges[0]?.node
}

/**
 * Get the value of a select from a string in the hacky proposed solution by Prismic:
 * https://community.prismic.io/t/iterating-select-values-in-template-from-other-document/818/2
 *
 * @param {string} value
 * @returns {string}
 */
export function getSelectValue(value) {
    const matches = value.match(/\[(.*?)\]/)

    if (matches) {
        return matches[1]
    }

    return value
}
